export default "__VITE_ASSET__BBwFGzsg__"